import Swiper from 'swiper/bundle';

export default class LogosMarquee {
    constructor() {
        this.settings = {
            $logosMarquee : $('.js-logos-marquee')
        };

        this.bindUIActions();
    }

    bindUIActions() {
        if(this.settings.$logosMarquee.length) {
            document.addEventListener("DOMContentLoaded", function(event){
                new Swiper('.js-logos-marquee-forward', {
                    slidesPerView: 'auto',
                    loop: true,
                    speed: 5000,
                    allowTouchMove: false,
                    autoplay: {
                        delay: 0,
                        pauseOnMouseEnter: true,
                    },
                    direction: 'horizontal',
                });

                new Swiper('.js-logos-marquee-backward', {
                    slidesPerView: 'auto',
                    loop: true,
                    speed: 5000,
                    allowTouchMove: false,
                    autoplay: {
                        delay: 0,
                        pauseOnMouseEnter: true,
                        reverseDirection: true
                    },
                    direction: 'horizontal',
                });
            });
        }
    }
}

new LogosMarquee();